const FIELDS = [
  {
    key: 'number',
    label: 'Loan',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-center',
    sortable: true,
    permissions: [],
  },
  {
    key: 'property.address',
    label: 'Address',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-lef',
    sortable: true,
    permissions: [],
  },
  {
    key: 'property.city',
    label: 'City',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-left',
    sortable: true,
    permissions: [],
  },
  {
    key: 'property.state',
    label: 'State',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-center',
    sortable: true,
    permissions: [],
  },
  {
    key: 'transaction_type',
    label: 'Type',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-left',
    sortable: true,
    permissions: [],
  },
  {
    key: 'checklist.funded',
    label: 'Funded Date',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-center',
    sortable: true,
    permissions: [],
  },
  {
    key: 'maturity_date',
    label: 'Maturity Date',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-center',
    sortable: true,
    permissions: [],
  },
  {
    key: 'amount',
    label: 'Loan Amt',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-right',
    sortable: true,
    permissions: [],
  },
  {
    key: 'entity.name',
    label: 'Entity Name',
    class: 'clickable',
    thClass: 'text-center',
    tdClass: 'text-center',
    sortable: true,
    permissions: [],
  },
];

export default {
  ACTIVE_FIELDS: FIELDS,
};



// WEBPACK FOOTER //
// ./src/components/my_deals/resources/fields/active.js